import React from "react";

const AppLogo = () => {
  return <h1>Pokedex App</h1>;
};

export default AppLogo;
